import { setPostStyleGuideTheme } from "@insite/client-framework/ThemeConfiguration";

const latoFontFamily =
    "family=Lato:ital,wght@0,100;0,300;0,400;0,700;0,900;1,100;1,300;1,400;1,700;1,900";
const materialFontFamily = "family=Material+Symbols+Outlined:opsz,wght,FILL,GRAD@24,400,0,0";

const setPostStyles = () => {
    // Add some post styleguide customizations. These cannot be overridden by the styleguide.
    setPostStyleGuideTheme({
        breakpoints: {
            //       xs,  sm,  md,  lg,   xl
            values: [240, 425, 768, 1024, 1200],
            maxWidths: [540, 1200, 1200, 1200, 1200],
        },
        typography: {
            fontFamilyImportUrl: `https://fonts.googleapis.com/css2?${latoFontFamily}&${materialFontFamily}&display=swap`,
            // 100: Thin
            // 300: Light
            // 400: Regular
            // 500: Medium
            // 600: Semibold
            // 700: Bold
            // 800: ExtraBold
            // 900: Black
        },
    });
};

export default setPostStyles;
